<section class="container privacy">
    <div class="headline">
        <h1 class="title">privacy statement</h1>
        <img src="../../../assets/privacy/privacy_policy.png" alt="privacy policy" class="icons">
    </div>

    <div class="content">
        <p>The WorldERP, Inc. takes your privacy seriously. Please read the following to learn more about
            our privacy policy. <br><a href="#">Click here</a> to view the practical tips developed by the
            federal government and technology industry to help you guard against Internet fraud, secure your
            computer and protect your personal information.</p>
        <p class="subtitle">What This Privacy Policy Covers</p>
        <ul>
            <li>
                <p>This policy covers how The WorldERP, Inc. treats personal information that The
                    WorldERP, Inc. Sites collect and receives, including information related to your past
                    use of The WorldERP, Inc. products and services.</p>
            </li>
            <li>
                <p>Personal information is information about you that is personally identifiable like your name,
                    address, email address, or phone number, and that is not otherwise publicly available.</p>
            </li>
            <li>
                <p>This policy does not apply to the practices of companies that The WorldERP, Inc. does
                    not own or control, or to people that The WorldERP, Inc. does not employ or manage.
                </p>
            </li>
        </ul>
        <p class="subtitle">Information Collection and Use</p>
        <p>General</p>
        <ul>
            <li>
                <p>The WorldERP, Inc. collects personal information when you register with a The
                    WorldERP, Inc. product, when you use The WorldERP, Inc. products or services,
                    or when you visit The WorldERP, Inc. site pages or the pages of certain The
                    WorldERP, Inc. partners. The WorldERP, Inc. may combine information about you
                    that we have with information we obtain from business partners or other companies.</p>
            </li>
            <li>
                <p>When you register we ask for information such as your name, email address, year of birth, zip
                    code, occupation, and personal interests. Once you register with The WorldERP, Inc.
                    and sign in to our services, you are not anonymous to us.</p>
            </li>
            <li>
                <p>The WorldERP, Inc. collects information about your transactions with us and with some
                    of our business partners.</p>
            </li>
            <li>
                <p>The WorldERP, Inc. automatically receives and records information on our server logs
                    from your browser.</p>
            </li>
            <li>
                <p>The WorldERP, Inc. uses information for the following general purposes: to customize
                    the shopping and content you see, fulfill your requests for products and services, improve
                    our services, contact you, conduct research, and provide anonymous reporting for internal
                    and external clients.</p>
            </li>
        </ul>
        <p class="subtitle">Information Sharing and Disclosure</p>
        <p>The WorldERP, Inc. does not rent, sell, or share personal information about you or your
            company with other people or nonaffiliated companies except to provide products or services you've
            requested, when we have your permission, or under the following circumstances:</p>
        <ul>
            <li>
                <p>We provide the information to trusted partners who work on behalf of or with The WorldERP, Inc. 
                    under confidentiality agreements. These companies may use your personal
                    information to help The WorldERP, Inc. communicate with you about offers from The
                    WorldERP, Inc. and our marketing partners. However, these companies do not have any
                    independent right to share this information.</p>
            </li>
            <li>
                <p>We respond to subpoenas, court orders, or legal process, or to establish or exercise our
                    legal rights or defend against legal claims;</p>
            </li>
            <li>
                <p>We believe it is necessary to share information in order to investigate, prevent, or take
                    action regarding illegal activities, suspected fraud, situations involving potential threats
                    to the physical safety of any person, violations of The WorldERP, Inc. terms of use,
                    or as otherwise required by law.</p>
            </li>
            <li>
                <p>We transfer information about you if The WorldERP, Inc. is acquired by or merged with
                    another company. In this event, The WorldERP, Inc. will notify you before information
                    about you is transferred and becomes subject to a different privacy policy.</p>
            </li>
            <li>
                <p>The WorldERP, Inc. works with vendors, partners, and other service providers in
                    different industries and categories of business.</p>
            </li>
        </ul>
        <p class="subtitle">Cookies</p>
        <ul>
            <li>
                <p>The WorldERP, Inc. may set and access The WorldERP, Inc. cookies on your
                    computer.</p>
            </li>
            <li>
                <p>The WorldERP, Inc. may use web beacons to access The WorldERP, Inc. cookies
                    inside and outside our network of web sites and in connection with The WorldERP, Inc.
                    products and services.</p>
            </li>
        </ul>
        <p class="subtitle">Your Ability to Edit and Delete Your Account Information and Preferences</p>
        <p>General</p>
        <ul>
            <li>
                <p>You can edit certain information in your The WorldERP, Inc. Account, however, most
                    information in your account is assigned and maintained buy your supervisor.</p>
            </li>
            <li>
                <p>We reserve the right to send you certain communications relating to The WorldERP, Inc.
                    service, such as service announcements, administrative messages and The WorldERP,
                    Inc. Newsletter, that are considered part of your The WorldERP, Inc. account, without
                    offering you the opportunity to opt-out of receiving them.</p>
            </li>
            <li>
                <p>Your supervisor can delete your The WorldERP, Inc. account by visiting our Staff setup
                    page. Please click here to read about information that might possibly remain in our archived
                    records after your account has been deleted.</p>
            </li>
        </ul>
        <p class="subtitle">Confidentiality and Security</p>
        <ul>
            <li>
                <p>We limit access to personal information about you to employees who we believe reasonably need
                    to come into contact with that information to provide products or services to you or in
                    order to do their jobs.</p>
            </li>
            <li>
                <p>We have physical, electronic, and procedural safeguards that comply with federal regulations
                    to protect personal information about you.</p>
            </li>
            <li>
                <p>To learn more about security, including the security steps we have taken and security steps
                    you can take, please read Security at The WorldERP, Inc.</p>
            </li>
        </ul>
        <p class="subtitle">Changes to this Privacy Policy</p>
        <ul>
            <li>
                <p>The WorldERP, Inc. may update this policy. We will notify you about significant
                    changes in the way we treat personal information by sending a notice to the primary email
                    address specified in your WorldERP, Inc. account or by placing a prominent notice on
                    our site.</p>
            </li>
        </ul>
        <p class="subtitle">Questions and Suggestions</p>
        <ul>
            <li>
                <p>If you have questions or suggestions, please complete a Contact-Us form or you can contact us
                    at:</p>
            </li>
        </ul>
        <p><b>By mail:<br>
                Privacy Policy<br>
                c/o The WorldERP, Inc.<br>
                1621 Central Ave.<br>
                Cheyenne, WY 82001</b></p>
        <p><b>Or by email: <span class="link email">moc.predlrow@lagel</span></b></p>
    </div>
</section>
